import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const TokenExpirationHandler = () => {
  // DISABLED: Token expiration handler to prevent annoying messages
  // const { tokenExpired, error, clearError } = useAuth();
  // const navigate = useNavigate();
  // const location = useLocation();

  // useEffect(() => {
  //   if (tokenExpired) {
  //     // Clear any existing errors
  //     clearError();
      
  //     // Don't redirect if already on login/signup page to prevent loops
  //     if (location.pathname === '/login' || location.pathname === '/signup') {
  //       console.log('Token expired but already on auth page, skipping redirect');
  //       return;
  //     }
      
  //     // Show a brief message to user
  //     console.log('Token expired, redirecting to login...');
      
  //     // Redirect to login page after a short delay
  //     setTimeout(() => {
  //       navigate('/login', { 
  //         replace: true,
  //         state: { 
  //           message: 'Your session has expired. Please log in again.',
  //           type: 'warning'
  //         }
  //       });
  //     }, 1000);
  //   }
  // }, [tokenExpired, navigate, clearError, location.pathname]);

  // This component doesn't render anything
  return null;
};

export default TokenExpirationHandler;
